export const GET_TASK_LIST = 'GET_TASK_LIST';
export const GET_TASK_LIST_SUCCESS = 'GET_TASK_LIST_SUCCESS';
export const GET_TASK_LIST_FAIL = 'GET_TASK_LIST_FAIL';

export const GET_SEMI_LIST_BY_TASK = 'GET_SEMI_LIST_BY_TASK';
export const GET_SEMI_LIST_BY_TASK_SUCCESS = 'GET_SEMI_LIST_BY_TASK_SUCCESS';
export const GET_SEMI_LIST_BY_TASK_FAIL = 'GET_SEMI_LIST_BY_TASK_FAIL';

export const GET_ZDVL_LIST_FOR_ADD = 'GET_ZDVL_LIST_FOR_ADD';
export const GET_ZDVL_LIST_FOR_ADD_SUCCESS = 'GET_ZDVL_LIST_FOR_ADD_SUCCESS';
export const GET_ZDVL_LIST_FOR_ADD_FAIL = 'GET_ZDVL_LIST_FOR_ADD_FAIL';

export const SAVE_TASK = 'SAVE_TASK';
export const SAVE_TASK_SUCCESS = 'SAVE_TASK_SUCCESS';
export const SAVE_TASK_FAIL = 'SAVE_TASK_FAIL';

export const ADD_TASK_ZDVL_LINE = 'ADD_TASK_ZDVL_LINE';
export const ADD_TASK_ZDVL_LINE_SUCCESS = 'ADD_TASK_ZDVL_LINE_SUCCESS';
export const ADD_TASK_ZDVL_LINE_FAIL = 'ADD_TASK_ZDVL_LINE_FAIL';

export const ADD_TASK_SEMI = 'ADD_TASK_SEMI';
export const ADD_TASK_SEMI_SUCCESS = 'ADD_TASK_SEMI_SUCCESS';
export const ADD_TASK_SEMI_FAIL = 'ADD_TASK_SEMI_FAIL';

export const DELETE_TASK_ZDVL_LINE = 'DELETE_TASK_ZDVL_LINE';
export const DELETE_TASK_ZDVL_LINE_SUCCESS = 'DELETE_TASK_ZDVL_LINE_SUCCESS';
export const DELETE_TASK_ZDVL_LINE_FAIL = 'DELETE_TASK_ZDVL_LINE_FAIL';

export const DELETE_TASK_SEMI = 'DELETE_TASK_SEMI';
export const DELETE_TASK_SEMI_SUCCESS = 'DELETE_TASK_SEMI_SUCCESS';
export const DELETE_TASK_SEMI_FAIL = 'DELETE_TASK_SEMI_FAIL';

export const DELETE_TASK = 'DELETE_TASK';
export const DELETE_TASK_SUCCESS = 'DELETE_TASK_SUCCESS';
export const DELETE_TASK_FAIL = 'DELETE_TASK_FAIL';

export const UPDATE_TASK = 'UPDATE_TASK';
export const UPDATE_TASK_SUCCESS = 'UPDATE_TASK_SUCCESS';
export const UPDATE_TASK_CLEAR = 'UPDATE_TASK_CLEAR';
export const UPDATE_TASK_FAIL = 'UPDATE_TASK_FAIL';

export const SET_OPEN_CLOSE_TASK = 'SET_OPEN_CLOSE_TASK';
export const SET_OPEN_CLOSE_TASK_SUCCESS = 'SET_OPEN_CLOSE_TASK_SUCCESS';
export const SET_OPEN_CLOSE_TASK_FAIL = 'SET_OPEN_CLOSE_TASK_FAIL';

export const SET_INITIAL_STATE_TASK = 'SET_INITIAL_STATE_TASK';
